import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content"]

  clearForm(event) {
    // Check if the submission was successful
    // Turbo returns fetchResponse with succeeded property for successful requests
    const { fetchResponse } = event.detail

    // Check for success status (2xx responses including 204 No Content)
    if (fetchResponse && (fetchResponse.succeeded || fetchResponse.response?.ok)) {
      this.contentTarget.value = ""
      this.contentTarget.focus()
    }
  }
}
